const dataOrder = {
  education: {
    labels: [
      "University/College",
      "Secondary",
      "Primary",
      "No formal education"
    ],
    structure: [
      { education: "No formal education" },
      { education: "Primary" },
      { education: "Secondary" },
      { education: "University/College" }
    ]
  },
  gender: {
    labels: ["Female", "Male"],
    structure: [{ gender: "Male" }, { gender: "Female" }]
  },
  crossing_freq: {
    labels: ["Monthly", "Weekly", "Daily", "Never"],
    structure: [
      { crossing_freq: "Never" },
      { crossing_freq: "Daily" },
      { crossing_freq: "Weekly" },
      { crossing_freq: "Monthly" }
    ]
  },
  age: {
    labels: ["10-20", "20-30", "30-40", "40-50", "50-60", "60-70"],
    structure: [
      { age: "10-20" },
      { age: "20-30" },
      { age: "30-40" },
      { age: "40-50" },
      { age: "50-60" },
      { age: "60-70" }
    ]
  },
  country_of_residence: {
    labels: ["KEN", "RWA", "TZA", "UGA"],
    structure: [
      { country_of_residence: "KEN" },
      { country_of_residence: "UGA" },
      { country_of_residence: "RWA" },
      { country_of_residence: "TZA" }
    ]
  },
  primary_income: {
    labels: ["No", "Yes"],
    structure: [{ primary_income: "Yes" }, { primary_income: "No" }]
  },
  language: {
    labels: ["English", "Kinyarwanda", "Luganda", "Lukiga", "Swahili"],
    structure: [
      { language: "English" },
      { language: "Swahili" },
      { language: "Luganda" },
      { language: "Kinyarwanda" },
      { language: "Lukiga" }
    ]
  },
  produce: {
    labels: ["No", "Yes"],
    structure: [{ produce: "Yes" }, { produce: "No" }]
  },
  //   // TODO: add a comma here ☝️ when you uncomment the code
  procedurecommodity: {
    labels: [
      "Arrow Roots (nduma)",
      "Avocado",
      "Avocados",
      "Bananas",
      "Bananas - Matoke",
      "Bananas Cooking",
      "Bananas Ripe",
      "Beans",
      "Brinjals/Eggplant",
      "Bulls & Cows",
      "Bulls/Cows",
      "Cabbage",
      "Capsicums/pepper",
      "Carrots",
      "Cashew Nuts",
      "Cauliflower",
      "Chicken (Broiler)",
      "Chicken (Local)",
      "Chickens (Local)",
      "Chillies",
      "Clothes  & Shoes (New)",
      "Clothes (New)",
      "Clothes (Used)",
      "Clothes and Shoes (New)",
      "Clothes and Shoes (Used)",
      "Clothing and Shoes (Used)",
      "Cosmetics",
      "Cowpeas",
      "Cucumber",
      "Dolichos (Njahi)",
      "Duck",
      "Eggs",
      "Flowers",
      "Fresh Cassava",
      "Fresh Nile Perch",
      "Fresh peas",
      "Geese",
      "Goat",
      "Goats",
      "Greengrams",
      "Groundnuts",
      "Guavas",
      "Guinea Fowl",
      "Hides & Skins",
      "Honey",
      "Honey (Natural)",
      "Irish Potatoes",
      "Kales",
      "Lemons",
      "Lime",
      "Maize",
      "Maize Cereal",
      "Maize Flour",
      "Mangoes",
      "Meat of bulls/cows/Goats/Sheep",
      "Milk",
      "Millet",
      "Millet Flour",
      "Mwezi Moja",
      "New Clothes",
      "New Clothing and Shoes",
      "Nile Perch",
      "Nile Perch Dried or Preserved ",
      "Omena",
      "Onions",
      "Oranges",
      "Passion fruits",
      "Pawpaws (papaya)",
      "Pineapples",
      "Plastics",
      "Rice - Husked",
      "Rice - Processed",
      "Sheep",
      "Shoes (New)",
      "Sorghum",
      "Sorghum Cereal",
      "Sorghum Flour",
      "Sorghum Grains",
      "Spinach",
      "Sweet Potatoes",
      "Tilapia",
      "Tilapia Dried or Preserved",
      "Tilapia Fresh",
      "Timber",
      "Tomatoes",
      "Watermelon",
      "Wheat Flour",
      "Wheat Grain"
    ],
    structure: [
      { procedurecommodity: "Arrow Roots (nduma)" },
      { procedurecommodity: "Avocado" },
      { procedurecommodity: "Avocados" },
      { procedurecommodity: "Bananas" },
      { procedurecommodity: "Bananas - Matoke" },
      { procedurecommodity: "Bananas Cooking" },
      { procedurecommodity: "Bananas Ripe" },
      { procedurecommodity: "Beans" },
      { procedurecommodity: "Brinjals/Eggplant" },
      { procedurecommodity: "Bulls & Cows" },
      { procedurecommodity: "Bulls/Cows" },
      { procedurecommodity: "Cabbage" },
      { procedurecommodity: "Capsicums/pepper" },
      { procedurecommodity: "Carrots" },
      { procedurecommodity: "Cashew Nuts" },
      { procedurecommodity: "Cauliflower" },
      { procedurecommodity: "Chicken (Broiler)" },
      { procedurecommodity: "Chicken (Local)" },
      { procedurecommodity: "Chickens (Local)" },
      { procedurecommodity: "Chillies" },
      { procedurecommodity: "Clothes  & Shoes (New)" },
      { procedurecommodity: "Clothes (New)" },
      { procedurecommodity: "Clothes (Used)" },
      { procedurecommodity: "Clothes and Shoes (New)" },
      { procedurecommodity: "Clothes and Shoes (Used)" },
      { procedurecommodity: "Clothing and Shoes (Used)" },
      { procedurecommodity: "Cosmetics" },
      { procedurecommodity: "Cowpeas" },
      { procedurecommodity: "Cucumber" },
      { procedurecommodity: "Dolichos (Njahi)" },
      { procedurecommodity: "Duck" },
      { procedurecommodity: "Eggs" },
      { procedurecommodity: "Flowers" },
      { procedurecommodity: "Fresh Cassava" },
      { procedurecommodity: "Fresh Nile Perch" },
      { procedurecommodity: "Fresh peas" },
      { procedurecommodity: "Geese" },
      { procedurecommodity: "Goat" },
      { procedurecommodity: "Goats" },
      { procedurecommodity: "Greengrams" },
      { procedurecommodity: "Groundnuts" },
      { procedurecommodity: "Guavas" },
      { procedurecommodity: "Guinea Fowl" },
      { procedurecommodity: "Hides & Skins" },
      { procedurecommodity: "Honey" },
      { procedurecommodity: "Honey (Natural)" },
      { procedurecommodity: "Irish Potatoes" },
      { procedurecommodity: "Kales" },
      { procedurecommodity: "Lemons" },
      { procedurecommodity: "Lime" },
      { procedurecommodity: "Maize" },
      { procedurecommodity: "Maize Cereal" },
      { procedurecommodity: "Maize Flour" },
      { procedurecommodity: "Mangoes" },
      { procedurecommodity: "Meat of bulls/cows/Goats/Sheep" },
      { procedurecommodity: "Milk" },
      { procedurecommodity: "Millet" },
      { procedurecommodity: "Millet Flour" },
      { procedurecommodity: "Mwezi Moja" },
      { procedurecommodity: "New Clothes" },
      { procedurecommodity: "New Clothing and Shoes" },
      { procedurecommodity: "Nile Perch" },
      { procedurecommodity: "Nile Perch Dried or Preserved " },
      { procedurecommodity: "Omena" },
      { procedurecommodity: "Onions" },
      { procedurecommodity: "Oranges" },
      { procedurecommodity: "Passion fruits" },
      { procedurecommodity: "Pawpaws (papaya)" },
      { procedurecommodity: "Pineapples" },
      { procedurecommodity: "Plastics" },
      { procedurecommodity: "Rice - Husked" },
      { procedurecommodity: "Rice - Processed" },
      { procedurecommodity: "Sheep" },
      { procedurecommodity: "Shoes (New)" },
      { procedurecommodity: "Sorghum" },
      { procedurecommodity: "Sorghum Cereal" },
      { procedurecommodity: "Sorghum Flour" },
      { procedurecommodity: "Sorghum Grains" },
      { procedurecommodity: "Spinach" },
      { procedurecommodity: "Sweet Potatoes" },
      { procedurecommodity: "Tilapia" },
      { procedurecommodity: "Tilapia Dried or Preserved" },
      { procedurecommodity: "Tilapia Fresh" },
      { procedurecommodity: "Timber" },
      { procedurecommodity: "Tomatoes" },
      { procedurecommodity: "Watermelon" },
      { procedurecommodity: "Wheat Flour" },
      { procedurecommodity: "Wheat Grain" }
    ]
  },
  procedurecommoditycat: {
    labels: [
      " Bees and Their Products",
      "Cereals",
      "Clothing & Shoes",
      "Cosmetics",
      "Fish Products",
      "Fruits",
      "Legumes",
      "Legumes ",
      "Livestock & Livestock Products",
      "Poultry",
      "Pulses",
      "Timber",
      "Tubers",
      "Vegetables"
    ],
    structure: [
      { procedurecommoditycat: " Bees and Their Products" },
      { procedurecommoditycat: "Cereals" },
      { procedurecommoditycat: "Clothing & Shoes" },
      { procedurecommoditycat: "Cosmetics" },
      { procedurecommoditycat: "Fish Products" },
      { procedurecommoditycat: "Fruits" },
      { procedurecommoditycat: "Legumes" },
      { procedurecommoditycat: "Legumes " },
      { procedurecommoditycat: "Livestock & Livestock Products" },
      { procedurecommoditycat: "Poultry" },
      { procedurecommoditycat: "Pulses" },
      { procedurecommoditycat: "Timber" },
      { procedurecommoditycat: "Tubers" },
      { procedurecommoditycat: "Vegetables" }
    ]
  },

  proceduredest: {
    labels: [
      "KEN",
      "KEN->TZA",
      "KEN->UGA",
      "Kenya->Tanzania",
      "Kenya->Uganda",
      "Maize",
      "OutsideEAC",
      "TZA->KEN",
      "UGA",
      "UGA->KEN"
    ],
    structure: [
      { proceduredest: "KEN" },
      { proceduredest: "KEN->TZA" },
      { proceduredest: "KEN->UGA" },
      { proceduredest: "Kenya->Tanzania" },
      { proceduredest: "Kenya->Uganda" },
      { proceduredest: "Maize" },
      { proceduredest: "OutsideEAC" },
      { proceduredest: "TZA->KEN" },
      { proceduredest: "UGA" },
      { proceduredest: "UGA->KEN" }
    ]
  },
  procedurerequireddocument: {
    labels: [
      "Bill of Lading",
      "Certificate of Origin",
      "Import Entry Declaration Form (SAD)",
      "Import Permit",
      "National ID Card/Passport",
      "Phytosanitary Certificate",
      "Simplified Certificate Of Origin (SCOO)",
      "Valid Invoice",
      "Yellow Fever Card"
    ],

    structure: [
      { procedurerequireddocument: "Bill of Lading" },
      { procedurerequireddocument: "Certificate of Origin" },
      { procedurerequireddocument: "Import Entry Declaration Form (SAD)" },
      { procedurerequireddocument: "Import Permit" },
      { procedurerequireddocument: "National ID Card/Passport" },
      { procedurerequireddocument: "Phytosanitary Certificate" },
      {
        procedurerequireddocument: "Simplified Certificate Of Origin (SCOO)"
      },
      { procedurerequireddocument: "Valid Invoice" },
      { procedurerequireddocument: "Yellow Fever Card" }
    ]
  },

  procedurerelevantagency: {
    labels: [
      "COMESA Trade Information Desk Office (TIDO)",
      "Kenya National Chamber of Commerce & Industry (KNCCI)",
      "Kenya Plant Health Inspectorate Service (KEPHIS)",
      "Kenya Revenue Authority (KRA)",
      "Ministry of Agriculture Animal Industry & Fisheries (MAAIF)",
      "National Biosafety Authority (NBA)",
      "PORT Health",
      "Uganda National Bureau of Standards (UNBS)",
      "Uganda Police Dpts",
      "Uganda Revenue Authority (URA)"
    ],

    structure: [
      {
        procedurerelevantagency: "COMESA Trade Information Desk Office (TIDO)"
      },
      {
        procedurerelevantagency:
          "Kenya National Chamber of Commerce & Industry (KNCCI)"
      },
      {
        procedurerelevantagency:
          "Kenya Plant Health Inspectorate Service (KEPHIS)"
      },
      { procedurerelevantagency: "Kenya Revenue Authority (KRA)" },
      {
        procedurerelevantagency:
          "Ministry of Agriculture Animal Industry & Fisheries (MAAIF)"
      },
      { procedurerelevantagency: "National Biosafety Authority (NBA)" },
      { procedurerelevantagency: "PORT Health" },
      {
        procedurerelevantagency: "Uganda National Bureau of Standards (UNBS)"
      },
      { procedurerelevantagency: "Uganda Police Dpts" },
      { procedurerelevantagency: "Uganda Revenue Authority (URA)" }
    ]
  },
  procedureorigin: {
    labels: ["EAC", "KEN", "Outside EAC", "OutsideEAC", "TZA->KEN"],
    structure: [
      { procedureorigin: "EAC" },
      { procedureorigin: "KEN" },
      { procedureorigin: "Outside EAC" },
      { procedureorigin: "OutsideEAC" },
      { procedureorigin: "TZA->KEN" }
    ]
  },
  commoditycountry: {
    labels: ["BDI", "DRC", "KEN", "MWI", "RWA", "SSD", "TZA", "UGA"],
    structure: [
      { commoditycountry: "BDI" },
      { commoditycountry: "DRC" },
      { commoditycountry: "KEN" },
      { commoditycountry: "MWI" },
      { commoditycountry: "RWA" },
      { commoditycountry: "SSD" },
      { commoditycountry: "TZA" },
      { commoditycountry: "UGA" }
    ]
  },
  commoditycountry: {
    labels: [
      "Arua",
      "Arusha",
      "Average",
      "BUSIA",
      "Babati",
      "Balaka",
      "Base",
      "Birambo",
      "Bugarama",
      "Bugiri",
      "Bugiri Market",
      "Buhanda",
      "Bujumbura",
      "Bukavu",
      "Bukavu (Kadutu)",
      "Bukoba",
      "Bungoma",
      "Busasamana",
      "Busia",
      "Butare",
      "Byumba",
      "Cereals - Maize",
      "Cereals - Other",
      "Chimbiya",
      "Code",
      "CongoNil",
      "Dar es Salaam - Temeke Tandika",
      "Dar es Salaam - llala Buguruni",
      "Dar es salaam",
      "Dodoma",
      "Dodoma - Kibaigwa",
      "Eldoret",
      "Embu",
      "Ementi",
      "Gacurabwenge",
      "Gahanga",
      "Gahoromani",
      "Gakenke",
      "Garisa",
      "Garissa",
      "Gasarenda",
      "Gaseke",
      "Gashyushya",
      "Gatore",
      "Gichumbi",
      "Gicumbi",
      "Gikongoro",
      "Gisenyi",
      "Gitega",
      "Goma",
      "Goma ",
      "Goma (Birere) ",
      "Goma Birere ",
      "Gulu",
      "Hoima",
      "ID ",
      "Iganga",
      "Ilala (Buguruni)",
      "Imenti",
      "Intunga",
      "Iringa",
      "Isingiro",
      "Isingiro Market",
      "Isiolo",
      "Jinja",
      "Juba",
      "KG",
      "Kabale",
      "Kabale Market",
      "Kabarole",
      "Kabarondo",
      "Kabaya",
      "Kagera - Bukoba",
      "Kajiado",
      "Kakam.",
      "Kakamega",
      "Kalerwe",
      "Kalerwe Market",
      "Kamega",
      "Kamembe",
      "Kampala",
      "Kamuli",
      "Kamuli Market",
      "Kamwendo",
      "Kamwendo Market",
      "Kamwenge",
      "Kapchorwa",
      "Karambi",
      "Karatina",
      "Karenge",
      "Kasese",
      "Kasese Market",
      "Kasumbalesa",
      "Kasumbalesa market",
      "Kasungu",
      "Kayenzi",
      "Kibaigwa",
      "Kibirizi",
      "Kiboga",
      "Kibungo",
      "Kibuye",
      "Kigali",
      "Kigoma",
      "Kilimanjaro - Moshi",
      "Kimironko",
      "Kimisagara",
      "Kirambo",
      "Kiramuruzi",
      "Kisenyi",
      "Kisii",
      "Kisumu",
      "Kitale",
      "Kitale ",
      "Kitui",
      "Kizi",
      "Kobero",
      "Kolwezi",
      "Kolwezi market",
      "Kyankwanzi",
      "Kyegegwa",
      "Kyenjonjo",
      "Likasi",
      "Likasi market",
      "Lindi",
      "Lira",
      "Liwonde",
      "Loitkt",
      "Loitoktok",
      "Lubumbashi",
      "Luwero Market",
      "MBSA",
      "Machakos",
      "Mahoko",
      "Majengo",
      "Makueni",
      "Malindi",
      "Mara - Musoma",
      "Masaka",
      "Masindi",
      "Matimba",
      "Mbale",
      "Mbale Market",
      "Mbarara",
      "Mbeya",
      "Mbeya - Mwanjelwa",
      "Mbsa",
      "Mchinji",
      "Meru",
      "Mitundu",
      "Mkando",
      "Mombasa",
      "Mponela",
      "Mubende",
      "Mubyangabo",
      "Muhanga",
      "Muhondo",
      "Mukamira",
      "Mulindi",
      "Musanze",
      "Musha",
      "Mvera",
      "Mwanga",
      "Mwanza",
      "Mzimba",
      "Mzuzu",
      "Nairobi",
      "Nakasero",
      "Nakawa",
      "Nakawa Market",
      "Nakuru",
      "Ndago",
      "Ngororero",
      "Ngozi",
      "Nkhamenya",
      "Nkhotakota",
      "Nkora",
      "Nyabugogo",
      "Nyagatare",
      "Nyakarambi",
      "Nyamata",
      "Nyamirambo",
      "Oloitoktok",
      "Owino",
      "Owino Market",
      "Rubavu",
      "Rubavu ",
      "Rubavu Market",
      "Ruhango",
      "Ruhengeri",
      "Ruhuha",
      "Rukiga",
      "Rukomo",
      "Rushashi",
      "Rwamagana",
      "Salima",
      "Shyorongi",
      "Songea",
      "Soroti",
      "TAVETA",
      "Tororo",
      "Tunduma",
      "Tunduma ",
      "Tunduma Market",
      "Uvira",
      "Uvira ",
      "Uvira (Maendeleo)",
      "Wajir",
      "Weight",
      "Yei",
      "Ziniya",
      "kakamega",
      "kg",
      "kirambo",
      "kisii",
      "kitale",
      "kitui"
    ],

    structure: [
      { commoditycountry: "Arua" },
      { commoditycountry: "Arusha" },
      { commoditycountry: "Average" },
      { commoditycountry: "BUSIA" },
      { commoditycountry: "Babati" },
      { commoditycountry: "Balaka" },
      { commoditycountry: "Base" },
      { commoditycountry: "Birambo" },
      { commoditycountry: "Bugarama" },
      { commoditycountry: "Bugiri" },
      { commoditycountry: "Bugiri Market" },
      { commoditycountry: "Buhanda" },
      { commoditycountry: "Bujumbura" },
      { commoditycountry: "Bukavu" },
      { commoditycountry: "Bukavu (Kadutu)" },
      { commoditycountry: "Bukoba" },
      { commoditycountry: "Bungoma" },
      { commoditycountry: "Busasamana" },
      { commoditycountry: "Busia" },
      { commoditycountry: "Butare" },
      { commoditycountry: "Byumba" },
      { commoditycountry: "Cereals - Maize" },
      { commoditycountry: "Cereals - Other" },
      { commoditycountry: "Chimbiya" },
      { commoditycountry: "Code" },
      { commoditycountry: "CongoNil" },
      { commoditycountry: "Dar es Salaam - Temeke Tandika" },
      { commoditycountry: "Dar es Salaam - llala Buguruni" },
      { commoditycountry: "Dar es salaam" },
      { commoditycountry: "Dodoma" },
      { commoditycountry: "Dodoma - Kibaigwa" },
      { commoditycountry: "Eldoret" },
      { commoditycountry: "Embu" },
      { commoditycountry: "Ementi" },
      { commoditycountry: "Gacurabwenge" },
      { commoditycountry: "Gahanga" },
      { commoditycountry: "Gahoromani" },
      { commoditycountry: "Gakenke" },
      { commoditycountry: "Garisa" },
      { commoditycountry: "Garissa" },
      { commoditycountry: "Gasarenda" },
      { commoditycountry: "Gaseke" },
      { commoditycountry: "Gashyushya" },
      { commoditycountry: "Gatore" },
      { commoditycountry: "Gichumbi" },
      { commoditycountry: "Gicumbi" },
      { commoditycountry: "Gikongoro" },
      { commoditycountry: "Gisenyi" },
      { commoditycountry: "Gitega" },
      { commoditycountry: "Goma" },
      { commoditycountry: "Goma " },
      { commoditycountry: "Goma (Birere) " },
      { commoditycountry: "Goma Birere " },
      { commoditycountry: "Gulu" },
      { commoditycountry: "Hoima" },
      { commoditycountry: "ID " },
      { commoditycountry: "Iganga" },
      { commoditycountry: "Ilala (Buguruni)" },
      { commoditycountry: "Imenti" },
      { commoditycountry: "Intunga" },
      { commoditycountry: "Iringa" },
      { commoditycountry: "Isingiro" },
      { commoditycountry: "Isingiro Market" },
      { commoditycountry: "Isiolo" },
      { commoditycountry: "Jinja" },
      { commoditycountry: "Juba" },
      { commoditycountry: "KG" },
      { commoditycountry: "Kabale" },
      { commoditycountry: "Kabale Market" },
      { commoditycountry: "Kabarole" },
      { commoditycountry: "Kabarondo" },
      { commoditycountry: "Kabaya" },
      { commoditycountry: "Kagera - Bukoba" },
      { commoditycountry: "Kajiado" },
      { commoditycountry: "Kakam." },
      { commoditycountry: "Kakamega" },
      { commoditycountry: "Kalerwe" },
      { commoditycountry: "Kalerwe Market" },
      { commoditycountry: "Kamega" },
      { commoditycountry: "Kamembe" },
      { commoditycountry: "Kampala" },
      { commoditycountry: "Kamuli" },
      { commoditycountry: "Kamuli Market" },
      { commoditycountry: "Kamwendo" },
      { commoditycountry: "Kamwendo Market" },
      { commoditycountry: "Kamwenge" },
      { commoditycountry: "Kapchorwa" },
      { commoditycountry: "Karambi" },
      { commoditycountry: "Karatina" },
      { commoditycountry: "Karenge" },
      { commoditycountry: "Kasese" },
      { commoditycountry: "Kasese Market" },
      { commoditycountry: "Kasumbalesa" },
      { commoditycountry: "Kasumbalesa market" },
      { commoditycountry: "Kasungu" },
      { commoditycountry: "Kayenzi" },
      { commoditycountry: "Kibaigwa" },
      { commoditycountry: "Kibirizi" },
      { commoditycountry: "Kiboga" },
      { commoditycountry: "Kibungo" },
      { commoditycountry: "Kibuye" },
      { commoditycountry: "Kigali" },
      { commoditycountry: "Kigoma" },
      { commoditycountry: "Kilimanjaro - Moshi" },
      { commoditycountry: "Kimironko" },
      { commoditycountry: "Kimisagara" },
      { commoditycountry: "Kirambo" },
      { commoditycountry: "Kiramuruzi" },
      { commoditycountry: "Kisenyi" },
      { commoditycountry: "Kisii" },
      { commoditycountry: "Kisumu" },
      { commoditycountry: "Kitale" },
      { commoditycountry: "Kitale " },
      { commoditycountry: "Kitui" },
      { commoditycountry: "Kizi" },
      { commoditycountry: "Kobero" },
      { commoditycountry: "Kolwezi" },
      { commoditycountry: "Kolwezi market" },
      { commoditycountry: "Kyankwanzi" },
      { commoditycountry: "Kyegegwa" },
      { commoditycountry: "Kyenjonjo" },
      { commoditycountry: "Likasi" },
      { commoditycountry: "Likasi market" },
      { commoditycountry: "Lindi" },
      { commoditycountry: "Lira" },
      { commoditycountry: "Liwonde" },
      { commoditycountry: "Loitkt" },
      { commoditycountry: "Loitoktok" },
      { commoditycountry: "Lubumbashi" },
      { commoditycountry: "Luwero Market" },
      { commoditycountry: "MBSA" },
      { commoditycountry: "Machakos" },
      { commoditycountry: "Mahoko" },
      { commoditycountry: "Majengo" },
      { commoditycountry: "Makueni" },
      { commoditycountry: "Malindi" },
      { commoditycountry: "Mara - Musoma" },
      { commoditycountry: "Masaka" },
      { commoditycountry: "Masindi" },
      { commoditycountry: "Matimba" },
      { commoditycountry: "Mbale" },
      { commoditycountry: "Mbale Market" },
      { commoditycountry: "Mbarara" },
      { commoditycountry: "Mbeya" },
      { commoditycountry: "Mbeya - Mwanjelwa" },
      { commoditycountry: "Mbsa" },
      { commoditycountry: "Mchinji" },
      { commoditycountry: "Meru" },
      { commoditycountry: "Mitundu" },
      { commoditycountry: "Mkando" },
      { commoditycountry: "Mombasa" },
      { commoditycountry: "Mponela" },
      { commoditycountry: "Mubende" },
      { commoditycountry: "Mubyangabo" },
      { commoditycountry: "Muhanga" },
      { commoditycountry: "Muhondo" },
      { commoditycountry: "Mukamira" },
      { commoditycountry: "Mulindi" },
      { commoditycountry: "Musanze" },
      { commoditycountry: "Musha" },
      { commoditycountry: "Mvera" },
      { commoditycountry: "Mwanga" },
      { commoditycountry: "Mwanza" },
      { commoditycountry: "Mzimba" },
      { commoditycountry: "Mzuzu" },
      { commoditycountry: "Nairobi" },
      { commoditycountry: "Nakasero" },
      { commoditycountry: "Nakawa" },
      { commoditycountry: "Nakawa Market" },
      { commoditycountry: "Nakuru" },
      { commoditycountry: "Ndago" },
      { commoditycountry: "Ngororero" },
      { commoditycountry: "Ngozi" },
      { commoditycountry: "Nkhamenya" },
      { commoditycountry: "Nkhotakota" },
      { commoditycountry: "Nkora" },
      { commoditycountry: "Nyabugogo" },
      { commoditycountry: "Nyagatare" },
      { commoditycountry: "Nyakarambi" },
      { commoditycountry: "Nyamata" },
      { commoditycountry: "Nyamirambo" },
      { commoditycountry: "Oloitoktok" },
      { commoditycountry: "Owino" },
      { commoditycountry: "Owino Market" },
      { commoditycountry: "Rubavu" },
      { commoditycountry: "Rubavu " },
      { commoditycountry: "Rubavu Market" },
      { commoditycountry: "Ruhango" },
      { commoditycountry: "Ruhengeri" },
      { commoditycountry: "Ruhuha" },
      { commoditycountry: "Rukiga" },
      { commoditycountry: "Rukomo" },
      { commoditycountry: "Rushashi" },
      { commoditycountry: "Rwamagana" },
      { commoditycountry: "Salima" },
      { commoditycountry: "Shyorongi" },
      { commoditycountry: "Songea" },
      { commoditycountry: "Soroti" },
      { commoditycountry: "TAVETA" },
      { commoditycountry: "Tororo" },
      { commoditycountry: "Tunduma" },
      { commoditycountry: "Tunduma " },
      { commoditycountry: "Tunduma Market" },
      { commoditycountry: "Uvira" },
      { commoditycountry: "Uvira " },
      { commoditycountry: "Uvira (Maendeleo)" },
      { commoditycountry: "Wajir" },
      { commoditycountry: "Weight" },
      { commoditycountry: "Yei" },
      { commoditycountry: "Ziniya" },
      { commoditycountry: "kakamega" },
      { commoditycountry: "kg" },
      { commoditycountry: "kirambo" },
      { commoditycountry: "kisii" },
      { commoditycountry: "kitale" },
      { commoditycountry: "kitui" }
    ]
  },
  commoditymarket: {
    labels: [
      "Arua",
      "Arusha",
      "Average",
      "BUSIA",
      "Babati",
      "Balaka",
      "Base",
      "Birambo",
      "Bugarama",
      "Bugiri",
      "Bugiri Market",
      "Buhanda",
      "Bujumbura",
      "Bukavu",
      "Bukavu (Kadutu)",
      "Bukoba",
      "Bungoma",
      "Busasamana",
      "Busia",
      "Butare",
      "Byumba",
      "Cereals - Maize",
      "Cereals - Other",
      "Chimbiya",
      "Code",
      "CongoNil",
      "Dar es Salaam - Temeke Tandika",
      "Dar es Salaam - llala Buguruni",
      "Dar es salaam",
      "Dodoma",
      "Dodoma - Kibaigwa",
      "Eldoret",
      "Embu",
      "Ementi",
      "Gacurabwenge",
      "Gahanga",
      "Gahoromani",
      "Gakenke",
      "Garisa",
      "Garissa",
      "Gasarenda",
      "Gaseke",
      "Gashyushya",
      "Gatore",
      "Gichumbi",
      "Gicumbi",
      "Gikongoro",
      "Gisenyi",
      "Gitega",
      "Goma",
      "Goma ",
      "Goma (Birere) ",
      "Goma Birere ",
      "Gulu",
      "Hoima",
      "ID ",
      "Iganga",
      "Ilala (Buguruni)",
      "Imenti",
      "Intunga",
      "Iringa",
      "Isingiro",
      "Isingiro Market",
      "Isiolo",
      "Jinja",
      "Juba",
      "KG",
      "Kabale",
      "Kabale Market",
      "Kabarole",
      "Kabarondo",
      "Kabaya",
      "Kagera - Bukoba",
      "Kajiado",
      "Kakam.",
      "Kakamega",
      "Kalerwe",
      "Kalerwe Market",
      "Kamega",
      "Kamembe",
      "Kampala",
      "Kamuli",
      "Kamuli Market",
      "Kamwendo",
      "Kamwendo Market",
      "Kamwenge",
      "Kapchorwa",
      "Karambi",
      "Karatina",
      "Karenge",
      "Kasese",
      "Kasese Market",
      "Kasumbalesa",
      "Kasumbalesa market",
      "Kasungu",
      "Kayenzi",
      "Kibaigwa",
      "Kibirizi",
      "Kiboga",
      "Kibungo",
      "Kibuye",
      "Kigali",
      "Kigoma",
      "Kilimanjaro - Moshi",
      "Kimironko",
      "Kimisagara",
      "Kirambo",
      "Kiramuruzi",
      "Kisenyi",
      "Kisii",
      "Kisumu",
      "Kitale",
      "Kitale ",
      "Kitui",
      "Kizi",
      "Kobero",
      "Kolwezi",
      "Kolwezi market",
      "Kyankwanzi",
      "Kyegegwa",
      "Kyenjonjo",
      "Likasi",
      "Likasi market",
      "Lindi",
      "Lira",
      "Liwonde",
      "Loitkt",
      "Loitoktok",
      "Lubumbashi",
      "Luwero Market",
      "MBSA",
      "Machakos",
      "Mahoko",
      "Majengo",
      "Makueni",
      "Malindi",
      "Mara - Musoma",
      "Masaka",
      "Masindi",
      "Matimba",
      "Mbale",
      "Mbale Market",
      "Mbarara",
      "Mbeya",
      "Mbeya - Mwanjelwa",
      "Mbsa",
      "Mchinji",
      "Meru",
      "Mitundu",
      "Mkando",
      "Mombasa",
      "Mponela",
      "Mubende",
      "Mubyangabo",
      "Muhanga",
      "Muhondo",
      "Mukamira",
      "Mulindi",
      "Musanze",
      "Musha",
      "Mvera",
      "Mwanga",
      "Mwanza",
      "Mzimba",
      "Mzuzu",
      "Nairobi",
      "Nakasero",
      "Nakawa",
      "Nakawa Market",
      "Nakuru",
      "Ndago",
      "Ngororero",
      "Ngozi",
      "Nkhamenya",
      "Nkhotakota",
      "Nkora",
      "Nyabugogo",
      "Nyagatare",
      "Nyakarambi",
      "Nyamata",
      "Nyamirambo",
      "Oloitoktok",
      "Owino",
      "Owino Market",
      "Rubavu",
      "Rubavu ",
      "Rubavu Market",
      "Ruhango",
      "Ruhengeri",
      "Ruhuha",
      "Rukiga",
      "Rukomo",
      "Rushashi",
      "Rwamagana",
      "Salima",
      "Shyorongi",
      "Songea",
      "Soroti",
      "TAVETA",
      "Tororo",
      "Tunduma",
      "Tunduma ",
      "Tunduma Market",
      "Uvira",
      "Uvira ",
      "Uvira (Maendeleo)",
      "Wajir",
      "Weight",
      "Yei",
      "Ziniya",
      "kakamega",
      "kg",
      "kirambo",
      "kisii",
      "kitale",
      "kitui"
    ],

    structure: [
      { commoditymarket: "Arua" },
      { commoditymarket: "Arusha" },
      { commoditymarket: "Average" },
      { commoditymarket: "BUSIA" },
      { commoditymarket: "Babati" },
      { commoditymarket: "Balaka" },
      { commoditymarket: "Base" },
      { commoditymarket: "Birambo" },
      { commoditymarket: "Bugarama" },
      { commoditymarket: "Bugiri" },
      { commoditymarket: "Bugiri Market" },
      { commoditymarket: "Buhanda" },
      { commoditymarket: "Bujumbura" },
      { commoditymarket: "Bukavu" },
      { commoditymarket: "Bukavu (Kadutu)" },
      { commoditymarket: "Bukoba" },
      { commoditymarket: "Bungoma" },
      { commoditymarket: "Busasamana" },
      { commoditymarket: "Busia" },
      { commoditymarket: "Butare" },
      { commoditymarket: "Byumba" },
      { commoditymarket: "Cereals - Maize" },
      { commoditymarket: "Cereals - Other" },
      { commoditymarket: "Chimbiya" },
      { commoditymarket: "Code" },
      { commoditymarket: "CongoNil" },
      { commoditymarket: "Dar es Salaam - Temeke Tandika" },
      { commoditymarket: "Dar es Salaam - llala Buguruni" },
      { commoditymarket: "Dar es salaam" },
      { commoditymarket: "Dodoma" },
      { commoditymarket: "Dodoma - Kibaigwa" },
      { commoditymarket: "Eldoret" },
      { commoditymarket: "Embu" },
      { commoditymarket: "Ementi" },
      { commoditymarket: "Gacurabwenge" },
      { commoditymarket: "Gahanga" },
      { commoditymarket: "Gahoromani" },
      { commoditymarket: "Gakenke" },
      { commoditymarket: "Garisa" },
      { commoditymarket: "Garissa" },
      { commoditymarket: "Gasarenda" },
      { commoditymarket: "Gaseke" },
      { commoditymarket: "Gashyushya" },
      { commoditymarket: "Gatore" },
      { commoditymarket: "Gichumbi" },
      { commoditymarket: "Gicumbi" },
      { commoditymarket: "Gikongoro" },
      { commoditymarket: "Gisenyi" },
      { commoditymarket: "Gitega" },
      { commoditymarket: "Goma" },
      { commoditymarket: "Goma " },
      { commoditymarket: "Goma (Birere) " },
      { commoditymarket: "Goma Birere " },
      { commoditymarket: "Gulu" },
      { commoditymarket: "Hoima" },
      { commoditymarket: "ID " },
      { commoditymarket: "Iganga" },
      { commoditymarket: "Ilala (Buguruni)" },
      { commoditymarket: "Imenti" },
      { commoditymarket: "Intunga" },
      { commoditymarket: "Iringa" },
      { commoditymarket: "Isingiro" },
      { commoditymarket: "Isingiro Market" },
      { commoditymarket: "Isiolo" },
      { commoditymarket: "Jinja" },
      { commoditymarket: "Juba" },
      { commoditymarket: "KG" },
      { commoditymarket: "Kabale" },
      { commoditymarket: "Kabale Market" },
      { commoditymarket: "Kabarole" },
      { commoditymarket: "Kabarondo" },
      { commoditymarket: "Kabaya" },
      { commoditymarket: "Kagera - Bukoba" },
      { commoditymarket: "Kajiado" },
      { commoditymarket: "Kakam." },
      { commoditymarket: "Kakamega" },
      { commoditymarket: "Kalerwe" },
      { commoditymarket: "Kalerwe Market" },
      { commoditymarket: "Kamega" },
      { commoditymarket: "Kamembe" },
      { commoditymarket: "Kampala" },
      { commoditymarket: "Kamuli" },
      { commoditymarket: "Kamuli Market" },
      { commoditymarket: "Kamwendo" },
      { commoditymarket: "Kamwendo Market" },
      { commoditymarket: "Kamwenge" },
      { commoditymarket: "Kapchorwa" },
      { commoditymarket: "Karambi" },
      { commoditymarket: "Karatina" },
      { commoditymarket: "Karenge" },
      { commoditymarket: "Kasese" },
      { commoditymarket: "Kasese Market" },
      { commoditymarket: "Kasumbalesa" },
      { commoditymarket: "Kasumbalesa market" },
      { commoditymarket: "Kasungu" },
      { commoditymarket: "Kayenzi" },
      { commoditymarket: "Kibaigwa" },
      { commoditymarket: "Kibirizi" },
      { commoditymarket: "Kiboga" },
      { commoditymarket: "Kibungo" },
      { commoditymarket: "Kibuye" },
      { commoditymarket: "Kigali" },
      { commoditymarket: "Kigoma" },
      { commoditymarket: "Kilimanjaro - Moshi" },
      { commoditymarket: "Kimironko" },
      { commoditymarket: "Kimisagara" },
      { commoditymarket: "Kirambo" },
      { commoditymarket: "Kiramuruzi" },
      { commoditymarket: "Kisenyi" },
      { commoditymarket: "Kisii" },
      { commoditymarket: "Kisumu" },
      { commoditymarket: "Kitale" },
      { commoditymarket: "Kitale " },
      { commoditymarket: "Kitui" },
      { commoditymarket: "Kizi" },
      { commoditymarket: "Kobero" },
      { commoditymarket: "Kolwezi" },
      { commoditymarket: "Kolwezi market" },
      { commoditymarket: "Kyankwanzi" },
      { commoditymarket: "Kyegegwa" },
      { commoditymarket: "Kyenjonjo" },
      { commoditymarket: "Likasi" },
      { commoditymarket: "Likasi market" },
      { commoditymarket: "Lindi" },
      { commoditymarket: "Lira" },
      { commoditymarket: "Liwonde" },
      { commoditymarket: "Loitkt" },
      { commoditymarket: "Loitoktok" },
      { commoditymarket: "Lubumbashi" },
      { commoditymarket: "Luwero Market" },
      { commoditymarket: "MBSA" },
      { commoditymarket: "Machakos" },
      { commoditymarket: "Mahoko" },
      { commoditymarket: "Majengo" },
      { commoditymarket: "Makueni" },
      { commoditymarket: "Malindi" },
      { commoditymarket: "Mara - Musoma" },
      { commoditymarket: "Masaka" },
      { commoditymarket: "Masindi" },
      { commoditymarket: "Matimba" },
      { commoditymarket: "Mbale" },
      { commoditymarket: "Mbale Market" },
      { commoditymarket: "Mbarara" },
      { commoditymarket: "Mbeya" },
      { commoditymarket: "Mbeya - Mwanjelwa" },
      { commoditymarket: "Mbsa" },
      { commoditymarket: "Mchinji" },
      { commoditymarket: "Meru" },
      { commoditymarket: "Mitundu" },
      { commoditymarket: "Mkando" },
      { commoditymarket: "Mombasa" },
      { commoditymarket: "Mponela" },
      { commoditymarket: "Mubende" },
      { commoditymarket: "Mubyangabo" },
      { commoditymarket: "Muhanga" },
      { commoditymarket: "Muhondo" },
      { commoditymarket: "Mukamira" },
      { commoditymarket: "Mulindi" },
      { commoditymarket: "Musanze" },
      { commoditymarket: "Musha" },
      { commoditymarket: "Mvera" },
      { commoditymarket: "Mwanga" },
      { commoditymarket: "Mwanza" },
      { commoditymarket: "Mzimba" },
      { commoditymarket: "Mzuzu" },
      { commoditymarket: "Nairobi" },
      { commoditymarket: "Nakasero" },
      { commoditymarket: "Nakawa" },
      { commoditymarket: "Nakawa Market" },
      { commoditymarket: "Nakuru" },
      { commoditymarket: "Ndago" },
      { commoditymarket: "Ngororero" },
      { commoditymarket: "Ngozi" },
      { commoditymarket: "Nkhamenya" },
      { commoditymarket: "Nkhotakota" },
      { commoditymarket: "Nkora" },
      { commoditymarket: "Nyabugogo" },
      { commoditymarket: "Nyagatare" },
      { commoditymarket: "Nyakarambi" },
      { commoditymarket: "Nyamata" },
      { commoditymarket: "Nyamirambo" },
      { commoditymarket: "Oloitoktok" },
      { commoditymarket: "Owino" },
      { commoditymarket: "Owino Market" },
      { commoditymarket: "Rubavu" },
      { commoditymarket: "Rubavu " },
      { commoditymarket: "Rubavu Market" },
      { commoditymarket: "Ruhango" },
      { commoditymarket: "Ruhengeri" },
      { commoditymarket: "Ruhuha" },
      { commoditymarket: "Rukiga" },
      { commoditymarket: "Rukomo" },
      { commoditymarket: "Rushashi" },
      { commoditymarket: "Rwamagana" },
      { commoditymarket: "Salima" },
      { commoditymarket: "Shyorongi" },
      { commoditymarket: "Songea" },
      { commoditymarket: "Soroti" },
      { commoditymarket: "TAVETA" },
      { commoditymarket: "Tororo" },
      { commoditymarket: "Tunduma" },
      { commoditymarket: "Tunduma " },
      { commoditymarket: "Tunduma Market" },
      { commoditymarket: "Uvira" },
      { commoditymarket: "Uvira " },
      { commoditymarket: "Uvira (Maendeleo)" },
      { commoditymarket: "Wajir" },
      { commoditymarket: "Weight" },
      { commoditymarket: "Yei" },
      { commoditymarket: "Ziniya" },
      { commoditymarket: "kakamega" },
      { commoditymarket: "kg" },
      { commoditymarket: "kirambo" },
      { commoditymarket: "kisii" },
      { commoditymarket: "kitale" },
      { commoditymarket: "kitui" }
    ]
  },
  commodityproduct: {
    labels: [
      "Agwedde Beans",
      "Amaranth",
      "Apple Bananas",
      "Apples",
      "Asian Rice",
      "Avocado",
      "Banana Bunch",
      "Beans",
      "Beans (K132)",
      "Beans Canadian",
      "Beans Mwitemania",
      "Beans Rosecoco",
      "Beef",
      "Beet Roots",
      "Black Beans (Dolichos)",
      "Brinjal/Eggplant",
      "Bull",
      "CEREAL",
      "Cabbages",
      "Capsicums",
      "Carrots",
      "Cassava - Fresh",
      "Cassava Chips",
      "Cassava Flour",
      "Cassava Fresh",
      "Cauliflower",
      "Cavendish (Bogoya)",
      "Chemical Fertilizer",
      "Chic Pea",
      "Chillies",
      "Coffee (Arabica)",
      "Coffee (Robusta)",
      "Cooking Bananas",
      "Cow",
      "Cow Peas",
      "Cow hide",
      "Cowpeas",
      "Cucumber",
      "Ditane",
      "Dolichos (Njahi)",
      "Dry Fermented Cassava",
      "Dry Maize",
      "Dry Peas",
      "Eggs",
      "Exotic Chicken",
      "Exotic Eggs",
      "Finger Millet",
      "French Beans",
      "Fresh Milk",
      "Fresh Peas",
      "Garlic",
      "Ginger",
      "Goat Meat",
      "Goats",
      "Green Beans",
      "Green Gram",
      "Green Maize",
      "Green Peas",
      "Ground Nuts",
      "Groundnuts",
      "Guava",
      "HORTICULTURE",
      "Imported Maize",
      "Imported Rice",
      "Irish Potatoes",
      "Kahama Rice",
      "Kales",
      "Kayiso Rice",
      "Kidney Beans",
      "Kilombero Rice",
      "Lemons",
      "Lettuce",
      "Limes",
      "Local Chicken",
      "Local Eggs",
      "Maize",
      "Maize Bran",
      "Maize Flour",
      "Maize Grain",
      "Mandarine",
      "Mangoes Local",
      "Mangoes Ngowe",
      "Mbeya Rice",
      "Milk",
      "Millet",
      "Millet Flour",
      "Millet Grain",
      "Mixed Beans",
      "Morogoro Rice",
      "Mutton",
      "Mwezi Moja",
      "NPK Fertilizer",
      "Nambale Beans",
      "Nile Perch",
      "OTHERS",
      "Old Beans",
      "Onions Dry",
      "Oranges",
      "Paddy Rice",
      "Parsley",
      "Passion Fruits",
      "Pawpaw",
      "Peas",
      "Pigeon Peas",
      "Pineapples",
      "Pork",
      "Processed Honey",
      "Pumpkins",
      "Red Beans",
      "Red Irish Potatoes",
      "Red Sorghum",
      "Rice",
      "Ripe Bananas",
      "Rwandan Rice",
      "Sheep",
      "Simsim",
      "Sorghum",
      "Sorghum Flour",
      "Sorghum Grain",
      "Soya Beans",
      "Soya beans",
      "Spring Onions",
      "Sun Dried Cassava",
      "Sunflower Seed",
      "Super Rice",
      "Sweet Bananas",
      "Sweet Potatoes",
      "Tanzanian  Rice",
      "Tilapia",
      "Tobacco",
      "Tomatoes",
      "Turkey",
      "Unprocessed Cotton",
      "Unprocessed Honey",
      "Unprocessed Tea",
      "Unprocessed Vanilla",
      "Upland Rice",
      "Urea Fertilisers",
      "Wheat",
      "Wheat Flour",
      "White Beans",
      "White Fleshed Sweet Potatoes",
      "White Irish Potatoes",
      "White Millet",
      "White Sorghum",
      "White beans",
      "Wood Charcoal",
      "Yellow Beans"
    ],

    structure: [
      { commodityproduct: "Agwedde Beans" },
      { commodityproduct: "Amaranth" },
      { commodityproduct: "Apple Bananas" },
      { commodityproduct: "Apples" },
      { commodityproduct: "Asian Rice" },
      { commodityproduct: "Avocado" },
      { commodityproduct: "Banana Bunch" },
      { commodityproduct: "Beans" },
      { commodityproduct: "Beans (K132)" },
      { commodityproduct: "Beans Canadian" },
      { commodityproduct: "Beans Mwitemania" },
      { commodityproduct: "Beans Rosecoco" },
      { commodityproduct: "Beef" },
      { commodityproduct: "Beet Roots" },
      { commodityproduct: "Black Beans (Dolichos)" },
      { commodityproduct: "Brinjal/Eggplant" },
      { commodityproduct: "Bull" },
      { commodityproduct: "CEREAL" },
      { commodityproduct: "Cabbages" },
      { commodityproduct: "Capsicums" },
      { commodityproduct: "Carrots" },
      { commodityproduct: "Cassava - Fresh" },
      { commodityproduct: "Cassava Chips" },
      { commodityproduct: "Cassava Flour" },
      { commodityproduct: "Cassava Fresh" },
      { commodityproduct: "Cauliflower" },
      { commodityproduct: "Cavendish (Bogoya)" },
      { commodityproduct: "Chemical Fertilizer" },
      { commodityproduct: "Chic Pea" },
      { commodityproduct: "Chillies" },
      { commodityproduct: "Coffee (Arabica)" },
      { commodityproduct: "Coffee (Robusta)" },
      { commodityproduct: "Cooking Bananas" },
      { commodityproduct: "Cow" },
      { commodityproduct: "Cow Peas" },
      { commodityproduct: "Cow hide" },
      { commodityproduct: "Cowpeas" },
      { commodityproduct: "Cucumber" },
      { commodityproduct: "Ditane" },
      { commodityproduct: "Dolichos (Njahi)" },
      { commodityproduct: "Dry Fermented Cassava" },
      { commodityproduct: "Dry Maize" },
      { commodityproduct: "Dry Peas" },
      { commodityproduct: "Eggs" },
      { commodityproduct: "Exotic Chicken" },
      { commodityproduct: "Exotic Eggs" },
      { commodityproduct: "Finger Millet" },
      { commodityproduct: "French Beans" },
      { commodityproduct: "Fresh Milk" },
      { commodityproduct: "Fresh Peas" },
      { commodityproduct: "Garlic" },
      { commodityproduct: "Ginger" },
      { commodityproduct: "Goat Meat" },
      { commodityproduct: "Goats" },
      { commodityproduct: "Green Beans" },
      { commodityproduct: "Green Gram" },
      { commodityproduct: "Green Maize" },
      { commodityproduct: "Green Peas" },
      { commodityproduct: "Ground Nuts" },
      { commodityproduct: "Groundnuts" },
      { commodityproduct: "Guava" },
      { commodityproduct: "HORTICULTURE" },
      { commodityproduct: "Imported Maize" },
      { commodityproduct: "Imported Rice" },
      { commodityproduct: "Irish Potatoes" },
      { commodityproduct: "Kahama Rice" },
      { commodityproduct: "Kales" },
      { commodityproduct: "Kayiso Rice" },
      { commodityproduct: "Kidney Beans" },
      { commodityproduct: "Kilombero Rice" },
      { commodityproduct: "Lemons" },
      { commodityproduct: "Lettuce" },
      { commodityproduct: "Limes" },
      { commodityproduct: "Local Chicken" },
      { commodityproduct: "Local Eggs" },
      { commodityproduct: "Maize" },
      { commodityproduct: "Maize Bran" },
      { commodityproduct: "Maize Flour" },
      { commodityproduct: "Maize Grain" },
      { commodityproduct: "Mandarine" },
      { commodityproduct: "Mangoes Local" },
      { commodityproduct: "Mangoes Ngowe" },
      { commodityproduct: "Mbeya Rice" },
      { commodityproduct: "Milk" },
      { commodityproduct: "Millet" },
      { commodityproduct: "Millet Flour" },
      { commodityproduct: "Millet Grain" },
      { commodityproduct: "Mixed Beans" },
      { commodityproduct: "Morogoro Rice" },
      { commodityproduct: "Mutton" },
      { commodityproduct: "Mwezi Moja" },
      { commodityproduct: "NPK Fertilizer" },
      { commodityproduct: "Nambale Beans" },
      { commodityproduct: "Nile Perch" },
      { commodityproduct: "OTHERS" },
      { commodityproduct: "Old Beans" },
      { commodityproduct: "Onions Dry" },
      { commodityproduct: "Oranges" },
      { commodityproduct: "Paddy Rice" },
      { commodityproduct: "Parsley" },
      { commodityproduct: "Passion Fruits" },
      { commodityproduct: "Pawpaw" },
      { commodityproduct: "Peas" },
      { commodityproduct: "Pigeon Peas" },
      { commodityproduct: "Pineapples" },
      { commodityproduct: "Pork" },
      { commodityproduct: "Processed Honey" },
      { commodityproduct: "Pumpkins" },
      { commodityproduct: "Red Beans" },
      { commodityproduct: "Red Irish Potatoes" },
      { commodityproduct: "Red Sorghum" },
      { commodityproduct: "Rice" },
      { commodityproduct: "Ripe Bananas" },
      { commodityproduct: "Rwandan Rice" },
      { commodityproduct: "Sheep" },
      { commodityproduct: "Simsim" },
      { commodityproduct: "Sorghum" },
      { commodityproduct: "Sorghum Flour" },
      { commodityproduct: "Sorghum Grain" },
      { commodityproduct: "Soya Beans" },
      { commodityproduct: "Soya beans" },
      { commodityproduct: "Spring Onions" },
      { commodityproduct: "Sun Dried Cassava" },
      { commodityproduct: "Sunflower Seed" },
      { commodityproduct: "Super Rice" },
      { commodityproduct: "Sweet Bananas" },
      { commodityproduct: "Sweet Potatoes" },
      { commodityproduct: "Tanzanian  Rice" },
      { commodityproduct: "Tilapia" },
      { commodityproduct: "Tobacco" },
      { commodityproduct: "Tomatoes" },
      { commodityproduct: "Turkey" },
      { commodityproduct: "Unprocessed Cotton" },
      { commodityproduct: "Unprocessed Honey" },
      { commodityproduct: "Unprocessed Tea" },
      { commodityproduct: "Unprocessed Vanilla" },
      { commodityproduct: "Upland Rice" },
      { commodityproduct: "Urea Fertilisers" },
      { commodityproduct: "Wheat" },
      { commodityproduct: "Wheat Flour" },
      { commodityproduct: "White Beans" },
      { commodityproduct: "White Fleshed Sweet Potatoes" },
      { commodityproduct: "White Irish Potatoes" },
      { commodityproduct: "White Millet" },
      { commodityproduct: "White Sorghum" },
      { commodityproduct: "White beans" },
      { commodityproduct: "Wood Charcoal" },
      { commodityproduct: "Yellow Beans" }
    ]
  },

  commoditycat: {
    labels: [
      "Animal Product",
      "Animal Products",
      "Beans",
      "Cereals - Maize",
      "Cereals - Other",
      "Cereals - Rice",
      "Dry Maize",
      "Farm Input",
      "Farm Inputs",
      "Fruits",
      "Fuel",
      "Green Gram",
      "Imported Rice",
      "Maharagwe",
      "Maize Flour",
      "Matunda",
      "Mixed Beans",
      "Nafaka ",
      "Nafaka Za Mahindi",
      "Other",
      "Peas",
      "Roots & Tubers",
      "Seeds & Nuts",
      "Vegetable",
      "Vegetables"
    ],
    structure: [
      { commoditycat: "Animal Product" },
      { commoditycat: "Animal Products" },
      { commoditycat: "Beans" },
      { commoditycat: "Cereals - Maize" },
      { commoditycat: "Cereals - Other" },
      { commoditycat: "Cereals - Rice" },
      { commoditycat: "Dry Maize" },
      { commoditycat: "Farm Input" },
      { commoditycat: "Farm Inputs" },
      { commoditycat: "Fruits" },
      { commoditycat: "Fuel" },
      { commoditycat: "Green Gram" },
      { commoditycat: "Imported Rice" },
      { commoditycat: "Maharagwe" },
      { commoditycat: "Maize Flour" },
      { commoditycat: "Matunda" },
      { commoditycat: "Mixed Beans" },
      { commoditycat: "Nafaka " },
      { commoditycat: "Nafaka Za Mahindi" },
      { commoditycat: "Other" },
      { commoditycat: "Peas" },
      { commoditycat: "Roots & Tubers" },
      { commoditycat: "Seeds & Nuts" },
      { commoditycat: "Vegetable" },
      { commoditycat: "Vegetables" }
    ]
  },

  exchangedirection: {
    labels: [
      "BIF->RWF",
      "CDF->RWF",
      "KES->RWF",
      "KES->TZS",
      "KES->UGX",
      "KES->USD",
      "RWF->BIF",
      "RWF->CDF",
      "RWF->KES",
      "RWF->TZS",
      "RWF->UGX",
      "RWF->USD",
      "TSH->KES",
      "TZS->KES",
      "TZS->RWF",
      "TZS->UGX",
      "TZS->USD",
      "UGX->KES",
      "UGX->RWF",
      "UGX->TZS",
      "UGX->USD",
      "USD->KES",
      "USD->RWF",
      "USD->TZS",
      "USD->UGX"
    ],

    structure: [
      { exchangedirection: "BIF->RWF" },
      { exchangedirection: "CDF->RWF" },
      { exchangedirection: "KES->RWF" },
      { exchangedirection: "KES->TZS" },
      { exchangedirection: "KES->UGX" },
      { exchangedirection: "KES->USD" },
      { exchangedirection: "RWF->BIF" },
      { exchangedirection: "RWF->CDF" },
      { exchangedirection: "RWF->KES" },
      { exchangedirection: "RWF->TZS" },
      { exchangedirection: "RWF->UGX" },
      { exchangedirection: "RWF->USD" },
      { exchangedirection: "TSH->KES" },
      { exchangedirection: "TZS->KES" },
      { exchangedirection: "TZS->RWF" },
      { exchangedirection: "TZS->UGX" },
      { exchangedirection: "TZS->USD" },
      { exchangedirection: "UGX->KES" },
      { exchangedirection: "UGX->RWF" },
      { exchangedirection: "UGX->TZS" },
      { exchangedirection: "UGX->USD" },
      { exchangedirection: "USD->KES" },
      { exchangedirection: "USD->RWF" },
      { exchangedirection: "USD->TZS" },
      { exchangedirection: "USD->UGX" }
    ]
  }
};

export default dataOrder;
